import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, LIMIT_MESSAGE, STATUS } from "../../../Constants";
import axios from "axios";
import { toast } from "react-toastify";


// For Send Message 
const sendMessageEndpoint = (args)=>`${DomainName}/page/sendmsg?userId=${args.userId}&userAccessToken=${args.pageToken}` ; 
export const sendTextMessageAPI = createAsyncThunk('message/sendText' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ; 
    console.log(args)
    try{
            await axios.post(sendMessageEndpoint(args) , {
            
                message:args.message,
                imageUrl:args.imageUrl
            
        } , {
            headers : {
                token : args.token
            }
        })

        return args.numMsg

    }catch(error){
        return rejectWithValue(error)
    }
})

// For Get Next Message 
const getNextMessageEndPoint = (args)=>`${DomainName}/page/msg?userAccessToken=${args.pageToken}&limit=${LIMIT_MESSAGE}&pageId=${args.pageId}&pagingTkn=${args.nextMessageToken}` ; 

export const getNextMessageAPI = createAsyncThunk('message/getNext' , async (args , thunkPAI)=>{
    const {rejectWithValue} = thunkPAI
    try{
        const response = await axios.get(getNextMessageEndPoint(args) , {
            headers :{
                token : args.token
            }
        })
        return response.data ; 
    }catch(err){
        return rejectWithValue(err) ; 
    }
})

// For Get All Messages
const getAllMessagesEndpoint = (args)=>`${DomainName}/page/msg?userAccessToken=${args.pageToken}&limit=${LIMIT_MESSAGE}&pageId=${args.pageId}` ;

export const getAllMessagesAPI = createAsyncThunk('messages/getAllMsg' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getAllMessagesEndpoint(args) , {
            headers :{
                token : args.token
            }
        })
        return response.data ;

    }catch(error){
        return rejectWithValue(error)
    }

})


// For Default State
const initialState = {
    allMessages : [] , 
    status : STATUS.IDLE , 
    hasNext : "" ,
    // hasBefore : "" 

}

const MessagesSlice = createSlice({
    name : "message" , 
    initialState , 
    reducers : {
        stopNext : (state )=>{
            state.status = STATUS.IDLE ;
        }
    } , 
    extraReducers : (builder)=>{
        builder 
        // For Get All Messages
        .addCase(getAllMessagesAPI.fulfilled , (state , action)=>{
            state.status = STATUS.SUCCESS ; 
            state.allMessages = action.payload.conversations ; 
            state.hasNext = action.payload.pagination.next !== undefined ? action.payload.pagination.cursors.after : ""  ; 
            // state.hasBefore = action.payload.pagination.previous !== undefined ? action.payload.pagination.cursors.before : ""  ; 
        })
        .addCase(getAllMessagesAPI.pending , (state , action)=>{
            state.status = STATUS.LOADDING ; 
        })
        .addCase(getAllMessagesAPI.rejected , (state , action)=>{
            state.status = STATUS.ERROR ; 
        })

        // For Send Message 
        .addCase(sendTextMessageAPI.fulfilled , (state ,action)=>{
            toast.success(`Messagae ${parseInt(action.payload) + 1} Sent `)
        })
        .addCase(sendTextMessageAPI.rejected , ()=>{
            toast.error("Something error please check Page Token")
        })

        // For Get The Next Message 
        .addCase(getNextMessageAPI.fulfilled , (state , action)=>{
            state.allMessages.push(...action.payload.conversations) ; 
            state.status = state.status === STATUS.IDLE ? STATUS.SUCCESS : STATUS.LOADDING
            state.hasNext = action.payload.pagination.next !== undefined ? action.payload.pagination.cursors.after : ""  ; 
        })
        .addCase(getNextMessageAPI.rejected , (state , action)=>{
            // state.status = STATUS.ERROR
        })
    }
})

export default MessagesSlice.reducer ;


export const getMessages = state => state.MessagesSlice ;

export const getNextMessageToken  = state => state.MessagesSlice.hasNext ;

export const {stopNext} = MessagesSlice.actions ; 